/*
 * routingUtility Actions
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 21-Jul-2025
 */

import { nullSafe } from 'Utility/globalMethods'
import { createAction } from './index'

export const actionTypes = {
  DO_SET_ENTRY_POINT: '@@routingUtility/set_entry_point',
  DO_SET_CURRENT_ENTRY_POINT: '@@routingUtility/set_current_entry_point'
  // @generator action:type
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
/** @action request

// @generator action:request

/** @action thunk
 * *
 *  entryPoint: string, The entry point path
 *  section: string  The section of the app (e.g., 'menu')
 *
 * @name doSetEntryPoint
 * @return {function} - Thunk action
 */
export const doSetEntryPoint = (entryPoint, section) => (dispatch, getState) => {
  const state = getState()
  dispatch(
    createAction(actionTypes.DO_SET_ENTRY_POINT, {
      payload: {
        entryPoint,
        section,
        router: nullSafe(() => state.router.previousLocations[1], { location: { pathname: '' } })
      }
    })
  )
}

/** @action thunk
 * * Insert a description
 * @name doSetCustomEntryPoint
 * @return {function} - Thunk action
 */
export const doSetCurrentEntryPoint = (payload) => (dispatch, getState) => {
  const state = getState()
  dispatch(
    createAction(actionTypes.DO_SET_CURRENT_ENTRY_POINT, {
      payload: {
        router: nullSafe(() => state.router.previousLocations[0], { location: { pathname: '' } })
      }
    })
  )
}

// @generator action
